import { useNavigate } from "react-router-dom";

export const useNavigateTo = (path: string) => {
  const navigate = useNavigate();
  return () => navigate(path);
};
